module.exports = __webpack_public_path__ + "files/bd1b4239b6faa5bdca85d754528d5a65.png";